<template>
  <div id="historico-page" class="container-fluid">
    <div >
      <div v-if="!this.leak_detail" class="col-md-2 col-sm-2 form-container">
        <div class="row" style="margin-top: 15px;">
          <label>CONSULTA DE EVENTOS</label>
        </div>
        <div class="row">          
          <date-picker style="width: 100%" :date="date" :option="option2" @change="validate($event, 'desde')"></date-picker>
          <span style="color: red; font-size: 10px; display:inline-block">{{desdeText}}</span>
        </div>
        <div class="row">
          <date-picker style="width: 100%" :date="date" :option="option" @change="validate($event, 'hasta')"></date-picker>
          <span style="color: red; font-size: 10px; display:inline-block">{{hastaText}}</span>
        </div>
        <div class="row">
          <select-c style="width: 100%" name="ductos" id="ductosHistorico" :options="ductos" placeholder="DUCTO" @changeSelect="selectEvent($event)"></select-c>
        </div>        
        <div class="row">
          <div style="display: flex; justify-content: space-between;">
            <button @click="search()" style="margin-left: 0" class="btn btn-default waves-effect" :class="[(desde === '' || ducto === '' || validation === false) ? 'disabled': '']">Buscar</button>
            <div style="margin-top: 15px;">
              <a href="#">
                <json-ex
                  :data   = "jsonData"
                  :fields = "jsonFields"
                  :name   = "`HDA-${desde}-${hasta}.xls`"
                  :meta   = "jsonMeta">
                <i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
                </json-ex>
              </a>
            </div>
          </div>
        </div>
         <div class="row" style="margin-top: 3vh">
          <label>PARAMETROS DE GRAFICA</label>
          <select-c name="tipo" id="tipo" :options="chartRange" placeholder="RANGO DE TIEMPO (MIN)" @changeSelect="selectChartRange($event)"></select-c>
         </div>
      </div>      
      <div :style="this.leak_detail ? 'width: 100%' : ''" :class="!this.leak_detail ? 'col-md-10 col-sm-10 chart-container' : 'chart-container'">
        <button v-if="selectedTramo" @click="print()" style="float: right; text-align: center; opacity: 0.9; margin: 0" class="btn btn-default waves-effect">
          Imprimir Reporte
        </button>
        <md-empty-state 
          v-if="!this.isChartVisible"
          md-icon="settings"
          md-label="Nada que graficar"
          md-description="Seleccione un rango de fechas, un ducto y el evento desde la tabla para graficar">
        </md-empty-state>    
        <div id="pressure-chart-div" class="chart-pressure" style="width: 100%; min-height: 42vh"></div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row" style="padding: 0; margin: 0;">
        <div class="col-md-6 col-sm-8  col-xs-12">
          <google-maps ref="map" :mcStyle="mcStyle" mcClass="half" :wStyle="wStyle" @marker-clicked="onMarkerClick"></google-maps>
        </div>
        <div class="col-md-6 col-sm-8 col-xs-12">
          <div class="panel-body">
            <table class="table">

              <thead>
                <tr class="text-center">
                  <th v-for="(row, key, index) in jsonFields" v-if="row!=='Id'" :key="key">{{key}}</th>
                </tr>
              </thead>

              <tbody>
                <tr class="info" v-for="(row, key) in (isMiddlePoint() && historicoMiddlePoints || historico)" :id="'alarm-' + key" :key="key" @click="onSelectRow(row)"
                  v-bind:class="{ selectedRow: selectedEventRow && row.id === selectedEventRow.id }" >
                  <td>{{row.id}}</td>
                  <td>{{row.section}}</td>
                  <td>{{row.fecha}}</td>
                  <td>{{row.hora}}</td>
                  <td>{{row.lat.toFixedDown(4)}}</td>
                  <td>{{row.lng.toFixedDown(4)}}</td>
                  <td>{{row.km}}</td>
                  <td v-if="isMiddlePoint()">{{row.tipo}}</td>
                  <td v-else-if="row.tipo === 1">Apertura</td>
                  <td v-else>Cierre</td>
                  <td>{{row.estado}}</td>
                  <td>{{row.municipio}}</td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
    <pdf-view hidden
      :event="selectedEventRow"      
      :chartRage="selectedChartRange"
      :mapImg="pdfMap"
      :chartCanvas="chartCanvas"
    ></pdf-view>
    <button id="loading-btn" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal-modal"></button>
    <modal :name="info.modalName" cclass="transparent">
      <loading-modal :info="info"></loading-modal>
    </modal>
  </div>
</template>

<script>
  require('ion-rangeslider')
  import JsonEx from 'vue-json-excel'
  import GoogleMaps from 'reusable/Map'
  import SelectC from 'reusable/Select'
  import PdfView from './PdfView'
  import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue'
  var echarts = require('echarts');
  let Modal = () => import('reusable/Modal')
  let LoadingModal = () => import('components/Modals/LoginModal')
  import toastr from 'toastr'
  import moment from 'moment'

  export default {
    data() {
      return {
        info: {
          modalName: 'loading-modal'
        },
        tipoOps: {
          uno: {
            name: 'Eventos',
            value: 0,
          },
          dos: {
            name: 'Puntos Medios',
            value: 3
          }
        },
        chartRange: [
          {
            name: '5 min',
            value: 5,
          },
          {
            name: '10 min',
            value: 10
          },
          {
            name: '15 min',
            value: 15,
          },          
          {
            name: '20 min',
            value: 20,
          },
          {
            name: '25 min',
            value: 25,
          },
          {
            name: '30 min',
            value: 30,
          }
        ],
        jsonData: [],
        eventsFields: {
          'Id': 'id',
          'Sección': 'section',
          'Fecha': 'fecha',
          'Hora': 'hora',
          'Lat': 'lat',
          'Lng': 'lng',
          'Km': 'km',
          'Tipo': 'tipo',
          'Estado': 'estado',
          'Municipio': 'municipio'
        },
        middlePointsFields: {
          'Id': 'id',
          'Fecha': 'fecha',
          'Lat': 'lat',
          'Lng': 'lng',
          'Km': 'km',
          'Eventos': 'tipo',
          'Estado': 'estado',
          'Municipio': 'municipio'
        },
        jsonFields: {
        },
        jsonMeta: [{'key' : 'charset', 'value' : 'utf-8'}],
        mcStyle: {
          height: '52vh'
        },
        wStyle: {
          padding: '0'
        },
        alarmType: undefined,
        date: this.$store.state.dpDate,
        option: this.$store.state.dpOpsHasta,
        option2: this.$store.state.dpOpsDesde,
        historico: [],
        historicoMiddlePoints: [],
        desde: '',
        hasta: '',
        ducto: '',
        ductos: [],
        kms: {},
        tipo: null,
        gd: {
          lat: '',
          lng: ''
        },
        gms: {
          lat: {
            check: {
              n: '',
              s: ''
            },
            g: '',
            m: '',
            s: ''
          },
          lng: {
            check: {
              e: '',
              o: ''
            },
            g: '',
            m: '',
            s: ''
          }
        },
        kmFrom: 0,
        kmTo: 10000,
        timer: null,
        validation: false,
        desdeText: '',
        hastaText: '',
        historicoTemp: [],
        selectedEventRow: null,
        selectedChartRange: 15,
        selectedTramo: null,
        selectedDucto: null,
        chartCanvas: [],
        pdfMap: null,
        leak_id: null,
        leak_detail: false,
        isChartVisible: false,
      }
    },
    watch: {
      historico() {
        this.$refs.map.fillMap(this.historico, this.ducto)
      },
      historicoMiddlePoints() {
        this.$refs.map.fillMap(this.historicoMiddlePoints, this.ducto)
      },
      markersFill() {
        this.$refs.map.fillMark()
      }
    },
    methods: {
      onMarkerClick(mark) {
        // this.isChartVisible = true;
        // const rows = (this.isMiddlePoint() && this.historicoMiddlePoints || this.historico);
        // this.selectedRow = rows.find(row => row.id === mark.customInfo);
        // this.fetchPressureChartData();
      },
      loading() {
        document.querySelector('#loading-btn').click()
      },
      filterByLatLng(type) {
        if(this.historico.length === 0) {
          return;
        }

        let temp = ''
        this.historico = this.historicoTemp

        if(type === 'gd'){
          temp = this.historico.filter(hist => {
            if(this.gd.lng && this.gd.lat) {
              return (Number(hist.lat) === Number(this.gd.lat) && Number(hist.lng) === Number(this.gd.lng))
            } else if(this.gd.lat && !this.gd.lng) {
              return Number(hist.lat) === Number(this.gd.lat)
            } else if(this.gd.lng && !this.gd.lat) {
              return Number(hist.lng) === Number(this.gd.lng)
            }
          })
        } else if(type === 'gms') {
          temp = this.historico.filter(hist => {
            if(this.gms.lat.g !== '' && this.gms.lat.m !== '' && this.gms.lat.s !== '') {
              let lat = (Number(this.gms.lat.g)) + Number((Number(this.gms.lat.m) / 60)) + Number((Number(this.gms.lat.s) / 3600))
              return Number(hist.lat) === Number(lat.toFixed(4))
            } else if(this.gms.lng.g !== '' && this.gms.lng.m !== '' && this.gms.lng.s !== '') {
                let lng = (Number(this.gms.lng.g)) + Number((Number(this.gms.lng.m) / 60)) + Number((Number(this.gms.lng.s) / 3600))
                return Number(String(hist.lng).split('-')[1] || String(hist.lng).split('-')[0]) === Number(lng.toFixed(4))
            }
          })
        }
        if(temp.length !== 0) {
          this.historicoTemp = this.historico
          this.historico = temp
        }
      },
      selectEvent(e) {
        this.ducto = document.querySelector(`#${e}`).value;
        let ductoFound = this.ductos && this.ductos.find(x => x.value === this.ducto);
        this.selectedDucto = ductoFound && ductoFound.name;
        const kmsData = this.kms[this.ducto]
        if(!kmsData) {
          return
        }
        this.kmFrom = kmsData.min
        this.kmTo = kmsData.max
      },
      selectType(e) {
        const type = document.querySelector(`#${e}`).value
        this.alarmType = type
        if(type === '3') {
            this.jsonFields = Object.assign({}, this.middlePointsFields)
            return
        }
        this.jsonFields = Object.assign({}, this.eventsFields)
      },
      selectChartRange(e){
        const minutes = document.querySelector(`#${e}`).value
        this.selectedChartRange = minutes;
        this.fetchPressureChartData();
      },
      isMiddlePoint() {
        return this.alarmType === 3 || this.alarmType === '3'
      },
      validate(e, d) {
        this[d] = e
        let max = this.hasta
        let min = this.desde
        if(max !== '' && (max <= min || min === '')) {
          this.desdeText = 'Este valor debe ser menor'
          this.hastaText = 'Este valor debe ser mayor'
          this.validation = false
        } else {
          this.desdeText = ''
          this.hastaText = ''
          this.validation = true
        }
      },
      historicoMark() {
        this.$refs.map.fillMark()
      },
      searchById(id) {
        this.loading()
        this.$store.dispatch('LOAD_HISTORICO_ID', {
          id: id
        })
        .then(resp => {
          this.handleResponse(resp);
        })
      },
      search() {
        if(!this.desde || !this.ducto || this.validation === false) {
            return
        }
        this.loading()
        let gms = ''
        let gd = ''
        let id = '';
        let tipo = document.querySelector('#tipo').value
        this.alarmType = tipo
        this.$store.dispatch('LOAD_HISTORICO', {
          desde: this.desde,
          hasta: this.hasta || '',
          id: id || null,
          ducto: this.ducto,
          tipo: tipo || null,
          kmFrom: this.kmFrom || null,
          kmTo: this.kmTo || null,
          gms: gms || null,
          gd: gd || null
        })
        .then(resp => {
          this.handleResponse(resp);
        })
      },
      handleResponse(resp) {
        let response = resp.data

        if(response.length === 0) {
          toastr.error('No se encontró información')
          this.loading()
          return
        }
        if(this.isMiddlePoint()) {
          this.historicoMiddlePoints = []
        } else {
          this.historico = []
        }
        if(this.isMiddlePoint()) {
          response.sort((a, b) => b.id_leak - a.id_leak);
          response.forEach(res => {
            this.historicoMiddlePoints.push({
              id: res.id_leak,
              km: res.avg_km,
              fecha: `${res.event_start} / ${res.event_end}`,
              lat: res.avg_n_lat || res.avg_lat,
              lng: res.avg_n_lon || res.avg_lon,
              tipo: res.events_count,
              estado: res.state,
              municipio: res.city,
              isMP: true
              // id: res.id_leak,
              // avg_km: res.avg_km,
              // avg_lat: res.avg_n_lat || res.avg_lat,
              // avg_lon: res.avg_n_lon || res.avg_lon,
              // city: res.city,
              // event_start: res.event_start,
              // event_end: res.event_end,
              // events_count: res.events_count,
              // section_id: res.section_id,
              // section_name: res.section_name,
              // site_id: res.site_id,
              // site_name: res.site_name,
              // state: res.state
            })
          })
          this.jsonData = this.historicoMiddlePoints
          this.historicoTemp = this.historicoMiddlePoints
        } else {
          response.sort((a, b) => b.id_leak - a.id_leak);

          response.forEach(res => {
            this.historico.push({
              id: res.id_leak,
              section: res.section_1_name,
              km: res.km,
              fecha: moment.utc(res.detection_timestamp).format('YYYY-MM-DD'),
              hora: moment.utc(res.detection_timestamp).format('HH:mm:ss'),
              lat: res.n_lat || res.lat,
              lng: res.n_lon || res.lon,
              tipo: res.type || 'No Data',
              estado: res.state_1_name || 'No Data',
              municipio: res.city_1_name || 'No Data',
              timestamp: res.detection_timestamp
            })
          })
          this.jsonData = this.historico
          this.historicoTemp = this.historico
        }

        if(this.leak_id) {
          // console.log(this.historico);
          var row = this.historico.find(s => s.id === parseInt(this.leak_id));
          // console.log(row);
          this.onSelectRow(row);
        } else {
          this.loading();
        }
      },
      updateInfo(res) {
       // data normalization.
        res.data = this.normalizedData(JSON.parse(JSON.stringify(res)));
      // getting min and max Y from normalized data.

        const minY = res.data.length == 0 ? 0 : res.data.reduce((min, p) => p.pressure < min ? p.pressure : min, res.data[0].pressure);
        const maxY = res.data.length == 0 ? 1 : res.data.reduce((max, p) => p.pressure > max ? p.pressure : max, res.data[0].pressure);

        let datasets = [
          { 
              name: res.site_one_name,
              type: 'line',
              symbolSize: 0,
              data: res.data
              .filter(x => x.id_rtu == res.site_one)
              .map(x => {
                    let returnArray = [];
                    returnArray.push(new Date(moment.utc(x.date_time).format('YYYY-MM-DD HH:mm:ss.ms')));
                    returnArray.push(x.pressure);
                  return returnArray;
              })
          },
          { 
              name: res.site_two_name,
              type: 'line',
              symbolSize: 0,
              data: res.data
              .filter(x => x.id_rtu == res.site_two)
              .map(x => {
                    let returnArray = [];
                    returnArray.push(new Date(moment.utc(x.date_time).format('YYYY-MM-DD HH:mm:ss.ms')));
                    returnArray.push(x.pressure);
                  return returnArray;
              })
          }
        ];
        if (this.selectedEventRow){
          datasets.push(
          {
            name: 'Fuga detectada',
            type: 'line',
            symbolSize: 0,
            lineStyle: {
              color: 'red', // Set the line color to red
              width: 3, // Set the line width to 3
            },
            data: [[this.selectedEventRow.timestamp, minY], [this.selectedEventRow.timestamp, maxY]]
          });
        }

        var option = { 
            legend: {
              show: true
            },              
            title: {
                text: 'PRESION NORMALIZADA'
            },
            tooltip: {
                trigger: 'axis',
                formatter: function(params){
                    let param = params[0]['value'];
                    return 'Tiempo: ' + moment(param[0]).format('HH:mm:ss.ms') + '<br/>' +
                    'Presión: ' + param[1];
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: 50,
                containLabel: true
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                      text: 'Descargar'
                    }
                }
            },
            dataZoom: [{
                type: 'slider',
                xAxisIndex: 0,
                filterMode: 'weakFilter',
                height: 20,
                bottom: 0,
                handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                handleSize: '80%',
                showDetail: false
            }, {
                type: 'inside',
                id: 'insideX',
                xAxisIndex: 0,
                filterMode: 'weakFilter',
                zoomOnMouseWheel: false,
                moveOnMouseMove: true
            }],
            xAxis: {
              type: 'time',
              boundaryGap: false,
              axisLabel: {
                formatter: function(value){
                    return moment(value).format('HH:mm:ss.ms')
                }
              }
              },
            yAxis: {
                type: 'value',
                min: minY,
                max: maxY
            },
            series: datasets
        };

        this.pressureChart.setOption(option, true);       
        this.selectedTramo = res.site_one_name.toUpperCase() + ' - ' + res.site_two_name.toUpperCase(); 
        this.pressureChart.hideLoading();
        this.getChartFromCanvas();        
      },
      normalizedData(res){
          if (res && res.data) {
              const siteOneData = res.data.filter(x => x.id_rtu == res.site_one);
              const siteTwoData = res.data.filter(x => x.id_rtu == res.site_two);
              
              let offsetSeries = 0;

              if(siteOneData && siteOneData.length > 0) {
                const sOneMinY = siteOneData ? siteOneData.reduce((min, p) => p.pressure < min ? p.pressure : min, siteOneData[0].pressure) : 0;
                const sOneMaxY = siteOneData ? siteOneData.reduce((max, p) => p.pressure > max ? p.pressure : max, siteOneData[0].pressure) : 0;

                siteOneData.map(res => {
                  const pr = res.pressure - sOneMinY;
                  const pn = pr / sOneMaxY;
                  res.pressure = pn.toFixed(4); 
                  return res;
                });

                let SiteOneAvg = siteOneData
                .reduce((a, s) => { a += Number(s.pressure); return a; }, 0) / siteOneData.length;
                siteOneData.map(res => {
                  const pn = Number(SiteOneAvg) + Number(res.pressure);               
                  res.pressure = pn.toFixed(4); 
                  return res;
                });

                const pnAvgMin = siteOneData.reduce((min, p) => p.pressure < min ? p.pressure : min, siteOneData[0].pressure);
                const pnAvgMax = siteOneData.reduce((max, p) => p.pressure > max ? p.pressure : max, siteOneData[0].pressure);
                offsetSeries = pnAvgMax - pnAvgMin;
              } else {
                toastr.error(`El sitio ${res.site_one_name} no tiene información`);
              }

              if(siteTwoData && siteTwoData.length > 0) {
                const sTwoMinY = siteTwoData.reduce((min, p) => p.pressure < min ? p.pressure : min, siteTwoData[0].pressure);
                const sTwoMaxY = siteTwoData.reduce((max, p) => p.pressure > max ? p.pressure : max, siteTwoData[0].pressure);
                
                siteTwoData.map(res => {
                  const pr = res.pressure - sTwoMinY;
                  const pn = pr / sTwoMaxY;
                  res.pressure = pn.toFixed(4); 
                  return res;
                });
                
                const SiteTwoAvg = (siteTwoData.reduce((a, s) => { a += Number(s.pressure); return a; }, 0) / siteTwoData.length) + offsetSeries;
                siteTwoData.map(res => {
                  const pn = Number(SiteTwoAvg) + Number(res.pressure);               
                  res.pressure = pn.toFixed(4); 
                  return res;
                });
              } else {
                toastr.error(`El sitio ${res.site_two_name} no tiene información`);
              }

              return siteOneData.concat(siteTwoData);                       
          }
      },
      async getChartFromCanvas(){
        await this.delay(2500);
        let canvas = document.querySelectorAll('div.chart-pressure canvas');        
        this.chartCanvas = canvas;
        if (this.selectedEventRow){
          this.selectedEventRow['ducto'] = this.selectedDucto;
          this.selectedEventRow['tramo'] = this.selectedTramo;
        }
        this.pdfMap = `https://maps.googleapis.com/maps/api/staticmap?center=${this.selectedEventRow.lat},${this.selectedEventRow.lng}&zoom=10&size=600x150&markers=color:red%7C${this.selectedEventRow.lat},${this.selectedEventRow.lng}&key=AIzaSyAA-A7plJZRYMqQp06YF7c-WL6nFU0YZnY`
      },
      async delay(ms) {        
        return await new Promise(resolve => setTimeout(resolve, ms));
      },
      onSelectRow(row){        
        this.isChartVisible = true;
        this.selectedEventRow = row;
        this.$refs.map.zoom(row);
        this.fetchPressureChartData();
      },
      fetchPressureChartData(){
        if(this.selectedEventRow) {
          this.selectedTramo = null;
          this.pressureChart.showLoading();
          this.$store.dispatch('LOAD_PRESSURE_BY_ID', {
            reportId: this.selectedEventRow.id,
            chartRange: this.selectedChartRange
          })
          .then(resp => {       
            this.pressureChart.hideLoading();   
            this.updateInfo(resp.data);
          });
        }
      },
      async print() {
        await this.delay(1600);
        this.getChartFromCanvas();
        var content = document.querySelector('.pdf-content').innerHTML
        var mywindow = window.open('', 'Print', 'height=600,width=800')        
        mywindow.document.write('<html><head><title>Print</title>')
        mywindow.document.write('</head><body>')
        // mywindow.document.write(content)
        // mywindow.document.write('</body>')
        mywindow.document.write('<style>')
        mywindow.document.write(`
          #pdf {
            width: 100%;
          }
            #row {
              padding: 25px;
            }
            img.logo{
              width: 200px;
            }

            img.logo_pem{
              float:right;
            }
            hr {
              color: var(--btn-default);
            }
            h4 {
              text-align: center;
              text-transform: uppercase;
              color: var(--btn-default);
            }
            .pdf__info {
              margin: 0 auto;
              display: block;
            }
            .pdf__titles {
              color: var(--btn-default);
            }
        
        .mydiv{
            background-color:#fff;
            font-family: 'Roboto', sans-serif;
            }
            .mydiv div#pdf{
              max-height:200px;
              height:200px;
            }
            .mydiv div#img_map{
              width:70%;
              margin:auto;
            }
            .mydiv div#linechart{
              display:none;
            }
            .mydiv img#leak{
                display:inline-block;
                width:115px;
              }
            .mydiv img#pem{
                padding-left: 400px;
                display:inline-block;
                width:115px;
              }
            .mydiv h4#h41{
                font-size:30px;
                font-weight:400;
                text-transform: uppercase;
                padding:0;
                margin-top:10px;
                margin-bottom:10px;
              }
            .mydiv hr#hr1{
                  background-color: #fff;
                  border-top: 2px solid var(--btn-default);
              }
            .mydiv span#titles{
              color: var(--btn-default);
              text-transform: uppercase;
              margin-left:4px;
            }
            .mydiv div#tablecontainer{
              height:440px;
            }
            .mydiv table#tableholder{
              height: 50%;
              width:100%;
              margin:0;
            }
            .mydiv thead#header{
              width:100%;
              padding:2px;
              background-color:var(--btn-default);
            }
            .mydiv tr#trh{
              width:100%;
              padding:2px;
              background-color:var(--btn-default);
            }
            .mydiv th#thh{
              font-size:12px;
              align:left;
              font-weight:400;
              padding:5px;
              border: 1.5px solid var(--btn-default);
            }
            .mydiv td#tdc{
              font-size:8px;
              text-align:center;
              padding:2px;
              border: 1px solid #777777;
            }
          
        `)
        mywindow.document.write('</style>')
        // mywindow.document.write('</head><body>')
        mywindow.document.write('<div class="mydiv">' + content + '</div>')
        mywindow.document.write('</body>')
        mywindow.document.write('</html>')
        mywindow.document.close()
        mywindow.focus()
        setTimeout(function() {
              mywindow.print()
              mywindow.close()
          }, 100)
          return true
    },
                
    },
    components: {
      SelectC,
      GoogleMaps,
      DatePicker,
      JsonEx,
      LoadingModal,
      Modal,
      PdfView      
    },
    mounted() {
      this.pressureChart = echarts.init(document.getElementById('pressure-chart-div'));      

      this.jsonFields = Object.assign({}, this.eventsFields)
        this.historicoMark()
        this.$store.dispatch('LOAD_OPS')
        .then(resp => {
          this.ductos = this.$store.getters.GET_OP({
            filteredBy: 'section_name'
          })
          this.kms = this.$store.getters.GET_KM_RANGE()
        })
        .catch(err => {
          console.log('Error', err)
        })
      $('#map-div').css('z-index', '0')
      $('#range').ionRangeSlider({
        min: 0,
        max: 0,
        from: 0,
        to: 0,
        type: 'double',
        prefix: 'KM ',
        grid: true,
        grid_num: 2,
        onChange: () => {
          this.kmFrom = $('#range').data().from
          this.kmTo = $('#range').data().to
        }
      });

      if(this.$route.params.id) {
        this.leak_detail = true;
        this.leak_id = this.$route.params.id;
        this.searchById(this.$route.params.id);
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import '~varmix';

  i {
    // padding: 15px;
    @include tablet {
      padding: 10px;
    }
  }

  .row {
    margin: 0;
    padding: 0;
  }

  .color-slider {
    padding: 15px !important;
  }

  .row {
    .title {
      font-size: 14px;
      @include tablet {
        width: 200px;
        display: inline-block;
        padding-top: 5px;
      }
      @include tablet {
        display: block;
      }
    }
    .sub {
      position: absolute;
      color: $inactive;
      font-weight: 500;
      font-size: 12px;
      @include tablet {
        display: inline-block;
      }
    }
    #borrar {
      height: 30px;
      font-size: 12px;
      padding-top: 1px;
      margin-top: -5px;
      i {
        font-size: inherit;
        padding: 0 !important;
      }
      @include tablet {
        display: block;
        margin: 30px auto;
      }
    }
    .bottom-input {
      @include tablet {
        margin-top: 20px;
        padding-left: 30px;
        margin-bottom: 50px;
      }
    }
    .input-field {
      display: inline-block;
      #latitud,
      #longitud {
        width: 100px;
        @include tablet {
          width: 70px;
        }
      }
      .input-3 {
        width: 40px;
        margin: 0 10px;
      }
    }
  }

  .btn-default {
    &:hover,
    &:focus,
    &:active {
      background: $amarilloC !important;
    }
    @include tablet {
      margin: 25px;
    }
  }

  #historico-page {
    //padding-top: 70px;
    background-color: $bg;

    .form-container {
      overflow-y: scroll;
      height: 45vh;      
      overflow-x: hidden;
    }

    .chart-container {
      height: 45vh;      
      #line-chart {
        width: auto;
        height: auto;
      }
    }

  }

  // range
  .color-2 .irs-bar,
  .color-2 .irs-bar-edge {
    background: red;
  }

  .col-md-6,
  .col-xs-12 {
    margin: 0;
    padding: 0;
  }

  .container-fluid {
    background-color: white;
    width: 100%;
    padding: 0;
    margin: 0;
  }
  .panel-body {
    height: 52vh; // width: 50vw;
  }
  table,
  .panel-body {
    overflow: scroll;
    padding: 0;   
    margin: 0;
    @include tablet {
      padding: 0;
    }
    .info {
      cursor: pointer;
      background-color: #fff;
     td{
      text-align: left;
      padding-left: 25px;
      background-color: transparent;
     }
     &:hover {
        background-color: $gray;
      }
    }
    th {
      text-align: left;
      padding-left: 25px;
      background-color: var(--btn-header-bg);
      color: #fff;
      @include cMax(415px) {
        font-size: 12px;
      }
    }

    .nombre-alarma {
      background-color: $amarilloC;
      color: white;
    }
    .panel-body {
      padding: 0;
    }
    .panel-title {
      @include cMax(415px) {
        font-size: 12px;
      }
    }
    .selectedRow {
      background: var(--selected-row);
      color: #fff;
    }
    .selectedRow:hover {
      background: var(--selected-row-hover);
      color: #fff;
    }
  }
  #loading-modal-modal {
      background-color: $loading-modal-bg-color;
  }
#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}  
</style>



// WEBPACK FOOTER //
// Historico.vue?acf13aca